import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/assessments/page.tsx");
